import { StateCreator } from "zustand";

export interface CommentFilesSlice {
    commentFiles: File[];
    setCommentFiles: (files: File[]) => void;
    addCommentFiles: (files: File[]) => void;
    removeCommentFile: (index: number) => void;
    resetCommentFiles: () => void;
}

const initialCommentFilesState: File[] = [];

export const createCommentFilesSlice: StateCreator<CommentFilesSlice, [], [], CommentFilesSlice> = (set) => ({
    commentFiles: initialCommentFilesState,
    setCommentFiles: (files) => set({ commentFiles: files }),
    addCommentFiles: (files) => set((state) => ({ commentFiles: [...state.commentFiles, ...files] })),
    removeCommentFile: (index) =>
        set((state) => {
            const copy = [...state.commentFiles];
            copy.splice(index, 1);
            return { commentFiles: copy };
        }),
    resetCommentFiles: () => set({ commentFiles: [] }),
});

